// api/quotes.js - VERSION STRUCTURÉE
import API from './index';

// Configuration
const API_CONFIG = {
  timeout: 30000, // 30 secondes
  retry: 3
};

const handleResponse = (response) => {
  if (response.data && response.data.success === false) {
    throw new Error(response.data.message || 'Erreur API');
  }
  return response.data;
};

const handleError = (error) => {
  console.error('API Error:', error);
  
  if (error.response) {
    // Erreur de réponse du serveur
   
    
    
    throw new Error('error message');

  } else if (error.request) {
    // Pas de réponse du serveur
    throw new Error('error message');

  } else {
    // Erreur de configuration
    throw new Error('error message');

  }
};

export const quotesAPI = {
  /**
   * Récupérer tous les devis avec filtres
   */
  getAll: async (params = {}) => {
    try {
      const response = await API.get('/quotes', { 
        params,
        timeout: API_CONFIG.timeout
      });
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },
  
  /**
   * Récupérer un devis par ID
   */
  getById: async (id) => {
    try {
      const response = await API.get(`/quotes/${id}`);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },
  
  /**
   * Créer un devis depuis l'admin
   */
  create: async (quoteData) => {
    try {
      const response = await API.post('/quotes', quoteData);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },
  
  /**
   * Créer un devis depuis le formulaire public
   */
  createPublic: async (quoteData) => {
    try {
      const response = await API.post('/quotes/public', quoteData, {
        timeout: API_CONFIG.timeout
      });
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },
  
  /**
   * Mettre à jour un devis
   */
  update: async (id, quoteData) => {
    try {
      const response = await API.put(`/quotes/${id}`, quoteData);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },
  
  /**
   * Supprimer un devis
   */
  delete: async (id) => {
    try {
      const response = await API.delete(`/quotes/${id}`);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },
  
  /**
   * Envoyer un devis par email
   */
  send: async (id) => {
    try {
      const response = await API.post(`/quotes/${id}/send`);
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },
  
  /**
   * Mettre à jour le statut
   */
  updateStatus: async (id, status) => {
    try {
      const response = await API.patch(`/quotes/${id}/status`, { status });
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  },
  
  /**
   * Récupérer les statistiques
   */
  getStats: async () => {
    try {
      const response = await API.get('/quotes/stats');
      return handleResponse(response);
    } catch (error) {
      throw handleError(error);
    }
  }
};